export default __webpack_public_path__ + "static/media/BT.d7ef8111.png";